module.exports = __webpack_public_path__ + "static/img/1-55.71eee35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-55.png
// module id = MAW1
// module chunks = 15